<div mat-dialog-title>
  <h1>Rankeo de sales orders</h1>
  <div class="warning-message">
    <p>
      <b>ACLARACI&Oacute;N: </b> El rankeo de las sales orders no agregadas sera
      basado a la fecha de vencimiento de cada sales order.
    </p>
  </div>
</div>

<mat-dialog-content>
  <div class="list-of-colors">
    <span>
      <mat-icon class="tw-text-gray-500">square</mat-icon>
      <p>No ha sido rankeada.</p>
    </span>
    <span>
      <mat-icon class="tw-text-lime-400">square</mat-icon>
      <p>Ya fue rankeada.</p>
    </span>
  </div>
  <app-scheduler-list orientation="vertical" [showFilterForm]="false">
    <ng-template appSchedulerItemOnList let-item="item">
      <span
        class="container-item"
        [ngClass]="{
          'item-inserted': item.isInserted,
          'item-not-inserted': !item.isInserted
        }"
      >
        <b>{{ item.transactionTitle }}</b> |
        {{ item.dueDate | date: "dd/MM/yyyy" }} |
        {{ item.quantityAsked | number: "2.2" }}
        {{ item.partNumberByCustomer ? " | " + item.partNumberByCustomer : "" }}
      </span>
    </ng-template>
  </app-scheduler-list>
</mat-dialog-content>
<mat-dialog-actions>
  <button [disabled]="this.disableRankSales"
    mat-raised-button (click)="onClose()" class="app-btn-save">
    Guardar cambios
  </button>
  <button mat-raised-button mat-dialog-close class="app-btn-close">
    Cancelar
  </button>
</mat-dialog-actions>
